import styled from "styled-components";
import propTypes from "prop-types";

const FlexItem = ({
  className,
  order,
  flexGrow,
  flexShrink,
  flexBasis,
  alignSelf,
  children,
  ...allProps
}) => {
  return (
    <Item
      className={className}
      order={order}
      flexGrow={flexGrow}
      flexShrink={flexShrink}
      flexBasis={flexBasis}
      alignSelf={alignSelf}
      {...allProps}
    >
      {children}
    </Item>
  );
};

FlexItem.propTypes = {
  className: propTypes.string,
  order: propTypes.number,
  flexGrow: propTypes.number,
  flexShrink: propTypes.number,
  flexBasis: propTypes.string,
  alignSelf: propTypes.string,
};

FlexItem.defaultProps = {
  order: 0,
  flexGrow: 0,
  flexShrink: 1,
  flexBasis: "auto",
  alignSelf: "auto",
};

const Item = styled.div`
  order: ${({ order }) => order};
  flex-grow: ${({ flexGrow }) => flexGrow};
  flex-shrink: ${({ flexShrink }) => flexShrink};
  flex-basis: ${({ flexBasis }) => flexBasis};
  align-self: ${({ alignSelf }) => alignSelf};
`;

export { FlexItem };
